/*
 * Copyright (c) 2026. Spin in het Web B.V. Apeldoorn NL.
 * Deze software is géén open source. Het auteursrecht van deze software
 * ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
 * Gebruik van deze software is onderhevig aan een licentieovereenkomst.
 * www.spininhetweb.nl
 */

/*
* index.ts
* 30-08-2026 - Jelmer Jellema - Spin in het Web B.V.
* Gegenereerd met Claude (AI), 30-08-2026
*/

export * from './sihwdatepicker';
